export * from './alpha.service';
import { AlphaService } from './alpha.service';
export * from './alpha.serviceInterface';
export * from './alphaRelease.service';
import { AlphaReleaseService } from './alphaRelease.service';
export * from './alphaRelease.serviceInterface';
export * from './answer.service';
import { AnswerService } from './answer.service';
export * from './answer.serviceInterface';
export * from './answerFlag.service';
import { AnswerFlagService } from './answerFlag.service';
export * from './answerFlag.serviceInterface';
export * from './answerWarning.service';
import { AnswerWarningService } from './answerWarning.service';
export * from './answerWarning.serviceInterface';
export * from './assignee.service';
import { AssigneeService } from './assignee.service';
export * from './assignee.serviceInterface';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './auth.serviceInterface';
export * from './betaRelease.service';
import { BetaReleaseService } from './betaRelease.service';
export * from './betaRelease.serviceInterface';
export * from './calculation.service';
import { CalculationService } from './calculation.service';
export * from './calculation.serviceInterface';
export * from './calculationPlan.service';
import { CalculationPlanService } from './calculationPlan.service';
export * from './calculationPlan.serviceInterface';
export * from './calculationPlanHistory.service';
import { CalculationPlanHistoryService } from './calculationPlanHistory.service';
export * from './calculationPlanHistory.serviceInterface';
export * from './category.service';
import { CategoryService } from './category.service';
export * from './category.serviceInterface';
export * from './chartType.service';
import { ChartTypeService } from './chartType.service';
export * from './chartType.serviceInterface';
export * from './client.service';
import { ClientService } from './client.service';
export * from './client.serviceInterface';
export * from './clientAnswer.service';
import { ClientAnswerService } from './clientAnswer.service';
export * from './clientAnswer.serviceInterface';
export * from './clientCategory.service';
import { ClientCategoryService } from './clientCategory.service';
export * from './clientCategory.serviceInterface';
export * from './clientQuestion.service';
import { ClientQuestionService } from './clientQuestion.service';
export * from './clientQuestion.serviceInterface';
export * from './clientQuestionDropdown.service';
import { ClientQuestionDropdownService } from './clientQuestionDropdown.service';
export * from './clientQuestionDropdown.serviceInterface';
export * from './comment.service';
import { CommentService } from './comment.service';
export * from './comment.serviceInterface';
export * from './config.service';
import { ConfigService } from './config.service';
export * from './config.serviceInterface';
export * from './configImport.service';
import { ConfigImportService } from './configImport.service';
export * from './configImport.serviceInterface';
export * from './copyToYear.service';
import { CopyToYearService } from './copyToYear.service';
export * from './copyToYear.serviceInterface';
export * from './country.service';
import { CountryService } from './country.service';
export * from './country.serviceInterface';
export * from './document.service';
import { DocumentService } from './document.service';
export * from './document.serviceInterface';
export * from './dropdown.service';
import { DropdownService } from './dropdown.service';
export * from './dropdown.serviceInterface';
export * from './fileSystem.service';
import { FileSystemService } from './fileSystem.service';
export * from './fileSystem.serviceInterface';
export * from './flag.service';
import { FlagService } from './flag.service';
export * from './flag.serviceInterface';
export * from './globalQuestion.service';
import { GlobalQuestionService } from './globalQuestion.service';
export * from './globalQuestion.serviceInterface';
export * from './language.service';
import { LanguageService } from './language.service';
export * from './language.serviceInterface';
export * from './manifest.service';
import { ManifestService } from './manifest.service';
export * from './manifest.serviceInterface';
export * from './missingInformation.service';
import { MissingInformationService } from './missingInformation.service';
export * from './missingInformation.serviceInterface';
export * from './note.service';
import { NoteService } from './note.service';
export * from './note.serviceInterface';
export * from './notice.service';
import { NoticeService } from './notice.service';
export * from './notice.serviceInterface';
export * from './noticeType.service';
import { NoticeTypeService } from './noticeType.service';
export * from './noticeType.serviceInterface';
export * from './notification.service';
import { NotificationService } from './notification.service';
export * from './notification.serviceInterface';
export * from './population.service';
import { PopulationService } from './population.service';
export * from './population.serviceInterface';
export * from './processState.service';
import { ProcessStateService } from './processState.service';
export * from './processState.serviceInterface';
export * from './question.service';
import { QuestionService } from './question.service';
export * from './question.serviceInterface';
export * from './smartFormLogic.service';
import { SmartFormLogicService } from './smartFormLogic.service';
export * from './smartFormLogic.serviceInterface';
export * from './smartFormType.service';
import { SmartFormTypeService } from './smartFormType.service';
export * from './smartFormType.serviceInterface';
export * from './source.service';
import { SourceService } from './source.service';
export * from './source.serviceInterface';
export * from './sourceAnswer.service';
import { SourceAnswerService } from './sourceAnswer.service';
export * from './sourceAnswer.serviceInterface';
export * from './sourceQuestion.service';
import { SourceQuestionService } from './sourceQuestion.service';
export * from './sourceQuestion.serviceInterface';
export * from './subcategory.service';
import { SubcategoryService } from './subcategory.service';
export * from './subcategory.serviceInterface';
export * from './subgroup.service';
import { SubgroupService } from './subgroup.service';
export * from './subgroup.serviceInterface';
export * from './taxReturn.service';
import { TaxReturnService } from './taxReturn.service';
export * from './taxReturn.serviceInterface';
export * from './taxReturnSourceFile.service';
import { TaxReturnSourceFileService } from './taxReturnSourceFile.service';
export * from './taxReturnSourceFile.serviceInterface';
export * from './taxReturnSubType.service';
import { TaxReturnSubTypeService } from './taxReturnSubType.service';
export * from './taxReturnSubType.serviceInterface';
export * from './taxReturnType.service';
import { TaxReturnTypeService } from './taxReturnType.service';
export * from './taxReturnType.serviceInterface';
export * from './taxYear.service';
import { TaxYearService } from './taxYear.service';
export * from './taxYear.serviceInterface';
export * from './template.service';
import { TemplateService } from './template.service';
export * from './template.serviceInterface';
export * from './templateType.service';
import { TemplateTypeService } from './templateType.service';
export * from './templateType.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export * from './userConfigs.service';
import { UserConfigsService } from './userConfigs.service';
export * from './userConfigs.serviceInterface';
export * from './warning.service';
import { WarningService } from './warning.service';
export * from './warning.serviceInterface';
export const APIS = [AlphaService, AlphaReleaseService, AnswerService, AnswerFlagService, AnswerWarningService, AssigneeService, AuthService, BetaReleaseService, CalculationService, CalculationPlanService, CalculationPlanHistoryService, CategoryService, ChartTypeService, ClientService, ClientAnswerService, ClientCategoryService, ClientQuestionService, ClientQuestionDropdownService, CommentService, ConfigService, ConfigImportService, CopyToYearService, CountryService, DocumentService, DropdownService, FileSystemService, FlagService, GlobalQuestionService, LanguageService, ManifestService, MissingInformationService, NoteService, NoticeService, NoticeTypeService, NotificationService, PopulationService, ProcessStateService, QuestionService, SmartFormLogicService, SmartFormTypeService, SourceService, SourceAnswerService, SourceQuestionService, SubcategoryService, SubgroupService, TaxReturnService, TaxReturnSourceFileService, TaxReturnSubTypeService, TaxReturnTypeService, TaxYearService, TemplateService, TemplateTypeService, UserService, UserConfigsService, WarningService];
